import * as React from 'react';
import { Text, TextProps, createStyles } from '@mantine/core';

const useStyles = createStyles((theme) => ({
    textColor: {
        color: theme.colors.brand[6],
        display: 'inline'
    }
}));

interface PrimaryTextProps extends TextProps {}

export const PrimaryText: React.FC<PrimaryTextProps> = ({ children, ...props }) => {
    const { classes } = useStyles();
    return (
        <Text fw="500" className={classes.textColor} {...props}>
            {children}
        </Text>
    );
};
